import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TokenService } from '../../../../service/token.service';
import { jsPDF } from 'jspdf';
import * as QRCode from 'qrcode';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ShipmentASN } from '../../../../service/shipment-asn.service';
import { GateInService } from '../../../../service/gate-in/gate-in.service';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrl: './token.component.scss'
})
export class TokenComponent implements OnInit {

  createTokenForm!: FormGroup
  ingredientForm!: FormGroup;

  asnNo: any[] = [];
  purpose = ["Loading", "Unloading"];
  vehicleTypeList: any[] = ['Small', 'Large', 'Medium', '12 Tyre', '15 Tyre', '16 Tyre', 'Other'];
  vendor_list: any[] = [];
  all_po_list: any[] = [];
  selected_po: any[] = [];
  driver_list: any[] = [];
  vehicle_list: any[] = [];
  vehicleTypes: any[] = [];
  getLoadingAndUnloadingPoint: any[] = [];
  loadingPoints: any = [] = [];
  unloadingPoints: any = [] = [];
  gateList:any[] = []

  reference!: string;
  generated_token_no!: string
  minDateValue!: Date;
  ingredient!: string;
  vendorStatus = "APPROVED"

  isDownload: boolean = false
  disableSubmit: boolean = true;
  byPO: boolean = false
  byASN: boolean = false
  asn_no:string =''
  plant:string =''
  vendor:string=''
  invoice:string=''
  invoice_callan_no:string=''

  responseValues: any[] = [];
  plantList: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private token: TokenService,
    private shipment_asn: ShipmentASN,
    private datePipe: DatePipe,
    private messageService: MessageService,
    private gateInService: GateInService,
    private vendorService: VendorTsService
  ) { }

  ngOnInit(): void {
    const tokenDetail = history.state;
    if (tokenDetail) {
      this.asn_no = tokenDetail.asn_no;
      this.plant = tokenDetail.plant;
      this.vendor=tokenDetail.vendor
      this.invoice=tokenDetail.invoice
      this.invoice_callan_no=tokenDetail.invoice_callan_no
    } else {
      console.log('No selected rows found.');
    }


    this.minDateValue = new Date();

    this.ingredientForm = this.formBuilder.group({
      ingredient: ['']
    });

    this.createTokenForm = this.formBuilder.group({
      plant: ['', Validators.required],
      gate: ['', Validators.required],
      purpose: ['', Validators.required],
      asn_no: [''],
      poagreement_no: [''],
      driver_name: [''],
      driver_mobile_no: [''],
      vehicle_type: [''],
      vehicle_no: [''],
      remark: [''],
      print_date_and_time: ['', Validators.required],
      ingredient: [],
      loading_unloading_point: [''],
      vendor:['']
    });


    this.token.getAsnNo().then(response => {
      this.asnNo = response.message
      if (this.invoice) {
        this.createTokenForm.get('asn_no')?.setValue(this.invoice)
      }
      if (this.vendor) {
        this.createTokenForm.get('vendor')?.setValue(this.vendor)
      }

    }).catch(error => {
      console.error("Error fetching ASN Number:", error);
    });

    this.shipment_asn.getVehicleTypeList().then(response => {
      this.vehicleTypes = response.message;
    }).catch(error => {
      console.error("Error fetching vehicle Types :", error);
    });
    this.getPlantList()
    this.getVendorList()
    this.getDriverList()
    this.getVehicleList()
    this.getLoadingUnloadingPoint()
    this.getPlantGateDetail()
    if (this.asn_no) {
      this.onAsnNoSelected(this.invoice)
      this.onIngredientChange('isASN')
      this.createTokenForm.get('ingredient')?.setValue('isASN')
    }
  }

  getPlantList() {
    this.shipment_asn
      .getPlantList()
      .then((res) => {
        this.plantList = res;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getLoadingUnloadingPoint() {
    this.shipment_asn.getLoadingAndUnloadingPoint().then((res) => {
      res.forEach((data: any) => {
        if (data.loading_unloading_point === 'Loading') {
          this.loadingPoints.push(data.name);
        } else if (data.loading_unloading_point === 'Unloading') {
          this.unloadingPoints.push(data.name);
        }
      });
    }).catch((error: any) => {
      console.log(error)
    })
  }

  onChangePurposeVlaue(val: any) {
    if (val === 'Loading') {
      this.getLoadingAndUnloadingPoint = this.loadingPoints;
    } else if (val === 'Unloading') {
      this.getLoadingAndUnloadingPoint = this.unloadingPoints;
    } else {
      this.getLoadingAndUnloadingPoint = [];
    }
  }

  onIngredientChange(event: any): void {
    this.ingredient = event
    if (this.ingredient == "isPO") {
      this.byPO = true
      this.byASN = false
    }
    if (this.ingredient == "isASN") {
      this.byASN = true
      this.byPO = false
    }
  }
  getGateDetail(gate:string):any{
    const Gate=this.gateList.find(item => item.name=== gate)
    return Gate.name
  }

  async getPlantGateDetail() {
    try {
      const isVendor = await this.vendorService.checkIfVendor();
      if (isVendor.message.isGateKeeper) {
        const response = await this.vendorService.getGateAndPlantDetail();
        if (response.message.plant_detail[0]?.name) {
          await this.getSelectetdPlant(response.message.plant_detail[0]?.name)
        }
        this.createTokenForm.patchValue({
          plant: response.message.plant_detail[0]?.name,
          gate:this.getGateDetail(response.message.gate_detail[0]?.name)
        });

      } else if (isVendor.message.isVendor) {
        this.createTokenForm.patchValue({
          plant: this.plant
        });
        if (this.plant) {
          await this.getSelectetdPlant(this.plant)
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }


  // getGateList() {
  //   this.shipment_asn.getGateList().then((res: any[]) => {
  //     // this.gateList = res;
  //   })
  //     .catch((error: any) => {
  //       console.log(error);
  //     });
  // }

  getVendorList() {
    this.vendorService.getVendorMasterList(this.vendorStatus)
      .then(result => {
        this.vendor_list=result.message
        // result.message.forEach((element: any) => {
        //  .push(element)
        // });
      }).catch((error) => {
        console.log(error);
      });
  }

  async getSelectetdPlant(plant: any) {
    try {
      const res = await this.shipment_asn.getGateFromPlant(plant);
      this.gateList = res.message.map((data: any) => ({ name: `${data}` }));
      if (this.plant) {
        this.createTokenForm.patchValue({
          gate:this.getGateDetail(this.gateList[0].name)
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  getselectedVendorPoList(vendor_code: any) {
    this.selected_po = []
    this.all_po_list = []
    this.token.getselectedVendorPoList(vendor_code).then((res) => {
      res.message.forEach((element: any) => {
        this.all_po_list.push(element.po)
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  getDriverList() {
    this.token.getDriverList().then((res) => {
      res.message.forEach((element: any) => {
        this.driver_list.push(element)
      });
    }).catch((error) => {
      console.log(error);
    });
  }
  onDriverChange(event: any) {
    const filteredDrivers = this.driver_list.filter(driver => driver.name === event);
    if (filteredDrivers.length > 0) {
      this.createTokenForm.patchValue({
        driver_mobile_no: filteredDrivers[0].mobile_no,
      });
    }
  }
  getVehicleList() {
    this.token.getVehicleList().then((res) => {
      res.message.forEach((element: any) => {
        this.vehicle_list.push(element)
      });
    }).catch((error) => {
      console.log(error);
    });
  }
  onVehicleChange(event: any) {
    const filteredVehicles = this.vehicle_list.filter(vehicle => vehicle.name === event);
    if (filteredVehicles.length > 0) {
      this.createTokenForm.patchValue({
        vehicle_type: filteredVehicles[0].vehicle_type,
      });
    }
  }

  onMultiSelectChange(event: any) {
    this.selected_po = event.value;
  }


  onAsnNoSelected(selectedValue: any) {
    this.fetchTokenDetails(selectedValue)
  }

  fetchTokenDetails(selectedAsn: string) {
    this.token.getTokenDetails(selectedAsn).then(response => {
      const poAgreementString = response.message[0]?.scheduleDeilveries
        .filter((item: { poagreementNo: any; }) => item.poagreementNo)
        .map((item: { poagreementNo: any; }) => item.poagreementNo)
        .join(', ');

      // Set poagreement_no form control with the string
      this.createTokenForm.get('poagreement_no')!.setValue(poAgreementString);
    }).catch(error => {
      console.error("Error fetching purpose details:", error);
    });

    this.token.getAsnDetail(selectedAsn).then(response => {
      const { driver, vehicle } = response.message;

      this.driver_list.forEach(driverItem => {
        if (driverItem.name === driver) {
          this.createTokenForm.patchValue({ driver_name: driver });
          this.onDriverChange(driver);
        }
      });

      this.vehicle_list.forEach(vehicleItem => {
        if (vehicleItem.name === vehicle) {
          this.createTokenForm.patchValue({ vehicle_no: vehicle });
          // this.onVehicleChange(vehicle);
        }
      });
    }).catch(error => {
      console.error("Error fetching purpose details:", error);
    });
  }

  enforceCharacterLimit(event: any): void {
    const inputValue: string = event.target.value;
    let maxLength = 13;

    const validPattern = /^\+?\d*$/;

    if (!validPattern.test(inputValue)) {
      event.target.value = '';
      this.createTokenForm.get('driver_mobile_no')!.setValue('');
      return;
    }

    if (!inputValue.startsWith('+')) {
      maxLength = 12;
    }

    if (inputValue.length > maxLength) {
      event.target.value = inputValue.substr(0, maxLength);
      this.createTokenForm.get('driver_mobile_no')!.setValue(event.target.value);
    }
  }
  validateNumber(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key) && !event.ctrlKey && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key)) {
      event.preventDefault();
    }
  }

  onSubmit() {
    const formattedDate = this.createTokenForm.get('print_date_and_time');
    const requiredFields = ['plant', 'gate', 'purpose', 'print_date_and_time'];

    if (!formattedDate || !formattedDate.value || requiredFields.some(field => !this.createTokenForm.get(field)?.value)) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all required fields' });
      return;
    }

    formattedDate.setValue(this.datePipe.transform(formattedDate.value, 'yyyy-MM-dd HH:mm:ss'));

    const asn_name = this.createTokenForm.get('asn_no');
    this.createTokenForm.get('asn_no')?.setValue(asn_name?.value);

    const tokenData = { ...this.createTokenForm.value };
    let poagreement_names = '';
    if (Array.isArray(tokenData.poagreement_no)) {
      poagreement_names = tokenData.poagreement_no.map((po: { name: any; }) => po.name).join(', ');
    } else {
      poagreement_names = tokenData.poagreement_no || '';
    }
    tokenData.poagreement_no = poagreement_names;

    this.token.createtoken(tokenData).then((res) => {
      const keysToRemove = ['name', 'owner', 'creation', 'modified', 'modified_by', 'docstatus', 'idx', 'doctype'];
      keysToRemove.forEach(key => {
        if (res.message.data.hasOwnProperty(key)) {
          delete res.message.data[key];
        }
      });

      this.responseValues = res.message.data;
       this.generated_token_no = res.message.data.token_no;

      if (res.message.status === "Success") {
        this.isDownload = true;
        this.disableSubmit = false;
        this.reference = '';
        this.messageService.add({ severity: "success", summary: 'Success', detail: res.message.message });
        this.createTokenForm.reset();

      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: res.message.message });
      }
    }).catch(() => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all required detail' });
    });
  }


  async generatePdfWithQRCode() {
    const doc = new jsPDF();

    // Extract only the 'generated_token_no' field for QR code
    const qrText = `Token No: ${this.generated_token_no}`;

    // Calculate position for QR code in the top-left corner
    const qrCodeSize = 30; // Size of the QR code image
    const margin = 10; // Margin from the edges of the page
    const qrCodeX = margin; // Adjusted position for top-left corner
    const qrCodeY = margin; // Adjusted position for top-left corner

    // Add QR code to PDF
    const qrCodeDataUrl = await QRCode.toDataURL(qrText);
    doc.addImage(qrCodeDataUrl, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize);

    // Print Token number next to the QR code
    const tokenText = `Token No: ${this.generated_token_no}`;
    const tokenTextWidth = tokenText.length * 0.12; // Estimation based on font size and text length
    const tokenTextX = qrCodeX + qrCodeSize + margin;
    const tokenTextY = qrCodeY + qrCodeSize / 2 + 5; // Adjusted vertically to center the text
    doc.text(tokenText, tokenTextX, tokenTextY);

    // Set starting position for fields below the QR code and token number
    let yPos = qrCodeY + qrCodeSize + margin * 2; // Adjusted to leave some space
    const lineHeight = 7; // Decreased line height for smaller text
    const fieldWidth = 60;

    // Set page borders
    doc.setDrawColor(0); // Black color
    doc.setLineWidth(0.2); // Border width
    doc.rect(5, 5, doc.internal.pageSize.getWidth() - 10, doc.internal.pageSize.getHeight() - 10, 'S'); // Draw border around the page

    // Add form values to PDF in table form (excluding 'generated_token_no')
    doc.setFontSize(10); // Decrease font size
    for (const [key, value] of Object.entries(this.responseValues)) {
      if (key !== 'generated_token_no') {
        const formattedFieldName = key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        doc.text(`${formattedFieldName}:`, 10, yPos);
        doc.text(`${value}`, 80, yPos);
        doc.line(10, yPos + 2, doc.internal.pageSize.getWidth() - 10, yPos + 2); // Extend line till the end of the page
        yPos += lineHeight;
      }
    }

    // Save the PDF
    doc.save('token.pdf');
    this.createTokenForm.reset();
  }

}
